import { forwardRef } from 'react';

import PartsContent from './parts-content';

type TPartFilter = {
  groups: TCategories;
  currentPart: string;
};

const PartsFilter = forwardRef(({ groups, currentPart }: TPartFilter, ref) => {
  return <PartsContent ref={ref} groups={groups} currentPart={currentPart} />;
});

PartsFilter.displayName = 'PartsFilter';

export default PartsFilter;
